module.exports = __webpack_public_path__ + "static/media/suggestedToFriends_10_15.974571ab.png";